import { connect } from 'react-redux';
import SpeedControlButton from './SpeedControlButton';
import { actions as videoActions } from '../../reducer';

const mapStateToProps = (state) => {
  return {
    playbackRate: state.video.get('playbackRate'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setPlaybackRate: (rate) => dispatch(videoActions.setPlaybackRate(rate)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SpeedControlButton);
